import type { Locale } from '@xphoto/shared';
import { fr, type Messages } from './messages.fr';
import { de } from './messages.de';
import { en } from './messages.en';

/** Registre des catalogues par langue. Toutes les langues partagent la forme `Messages`. */
export const catalogs: Record<Locale, Messages> = { fr, de, en };

/**
 * Chemins de clés valides, sous forme pointée (`'nav.home'`, `'theme.light'`…).
 * Dérivés du type `Messages` → toute clé inconnue est une erreur de compilation,
 * donc « zéro texte en dur » ET « pas de clé fantôme ».
 */
type Leaves<T> = {
  [K in keyof T & string]: T[K] extends string ? K : `${K}.${Leaves<T[K]>}`;
}[keyof T & string];

export type MessageKey = Leaves<Messages>;

/** Résout un chemin pointé dans un catalogue. Renvoie la clé brute si absente (dev-safe). */
export function resolve(messages: Messages, key: MessageKey): string {
  const value = key
    .split('.')
    .reduce<unknown>((acc, part) => (acc as Record<string, unknown>)?.[part], messages);
  return typeof value === 'string' ? value : key;
}
